document.querySelectorAll('[data-format-select]').forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();
    const value = link.dataset.formatSelect;
    const radio = document.querySelector(`[data-offer-radio][value="${value}"]`);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    document.dispatchEvent(new CustomEvent('contelune:open-personalization', { detail: { offer: value, trigger: link } }));
  });
});
